package uz.ferro.erp.feature.product.ui

import mui.material.Card
import mui.system.sx
import react.FC
import react.Props
import react.useContext
import uz.ferro.erp.Colors
import uz.ferro.erp.NavigationContext
import uz.ferro.erp.feature.product.model.Product
import uz.ferro.erp.feature.product.utils.getDataLimit
import uz.ferro.erp.feature.product.utils.getValidityDays
import uz.ferro.erp.ui.AppText
import uz.ferro.erp.ui.AppTextBold
import uz.ferro.erp.ui.AppTextMedium
import uz.ferro.erp.ui.ComponentSize
import uz.ferro.erp.ui.HorizontalLayout
import uz.ferro.erp.ui.VerticalLayout
import uz.ferro.erp.util.formatLocalCurrency
import uz.ferro.erp.util.localized
import web.cssom.AlignItems
import web.cssom.Cursor
import web.cssom.JustifyContent
import web.cssom.px

external interface ProductViewProps : Props {
    var product: Product
    var size: ComponentSize
    var isTranslucent: Boolean
    var onClick: (Product) -> Unit
}

val ProductItemView = FC<ProductViewProps> { props ->
    val product = props.product

    Card {
        sx {
            borderRadius = 15.px
            cursor = Cursor.pointer
        }

        onClick = {
            props.onClick(product)
        }

        VerticalLayout {
            space = 12.px
            sx {
                padding = 12.px
            }

            AppTextBold {
                text = product.title.localized()
            }

            HorizontalLayout {
                sx {
                    justifyContent = JustifyContent.spaceBetween
                }

                VerticalLayout {
                    sx {
                        alignItems = AlignItems.center
                    }

                    AppText {
                        text = "Muddati"
                        size = 14
                        color = Colors.textSecondary
                    }

                    AppTextMedium {
                        text = "${product.getValidityDays()} kun"
                        size = 16
                        color = Colors.accentColor
                    }
                }

                VerticalLayout {
                    sx {
                        alignItems = AlignItems.center
                    }

                    AppText {
                        text = "Internet"
                        size = 14
                        color = Colors.textSecondary
                    }

                    AppTextMedium {
                        text = product.getDataLimit()
                        size = 16
                        color = Colors.accentColor
                    }
                }

                VerticalLayout {
                    sx {
                        alignItems = AlignItems.center
                    }

                    AppText {
                        text = "Narxi"
                        size = 14
                        color = Colors.textSecondary
                    }

                    AppTextMedium {
                        text = product.localSellingPrice.formatLocalCurrency()
                        size = 16
                        color = Colors.accentColor
                    }
                }
            }
        }
    }
}